import { ref } from 'vue'
import { createInjectionState } from '@vueuse/shared'
import type { DirectusSchema } from '#root/types/content'

type DeliveryMethodsInitialData = DirectusSchema['delivery_methods']

const [useProvideDeliveryMethodsStore, useDeliveryMethodsStore] =
  createInjectionState((initialData: DeliveryMethodsInitialData) => {
    const items = ref(initialData)

    return {
      items
    }
  })

function useDeliveryMethodsStoreOrThrow() {
  const deliveryMethodsStore = useDeliveryMethodsStore()
  if (deliveryMethodsStore == null)
    throw new Error(
      'Please call `useProvideDeliveryMethodsStore` on the appropriate parent component'
    )
  return deliveryMethodsStore
}

export { useProvideDeliveryMethodsStore, useDeliveryMethodsStoreOrThrow }
